export const PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS = {
  PRIORITY: 'priority',
  STAY_DATE: 'stayDate',
} as const;

export type PortfolioSmartInsightsSortOption =
  (typeof PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS)[keyof typeof PORTFOLIO_SMART_INSIGHTS_SORT_OPTIONS];
